(function () {
  'use strict';

  var CONTENT = {
    metabolic: {
      yes: {
        heading: 'Using a GLP-1 medication?',
        body: 'GOOD FIBES®, included in your Metabolic Reset Bundle, combines 8 plant-based fiber sources, including prebiotic fibers and resistant starch, to support gut health, natural fullness, and healthy weight management as part of your overall metabolic wellness routine.\n\nAvailable in both jars and convenient Travel Packs, it’s an easy way to stay consistent wherever life takes you.'
      },
      thinking: {
        heading: 'Thinking about a GLP-1 medication?',
        body: 'Whether or not you decide to use a GLP-1 medication, increasing your daily fiber intake can help support gut health, natural fullness, and healthy weight management. GOOD FIBES®, included in your Metabolic Reset Bundle, combines 8 plant-based fiber sources, including prebiotic fibers and resistant starch, to help support your long-term metabolic wellness goals.'
      }
    },
    'DB + ACV': {
      yes: {
        heading: 'Using a GLP-1 medication?',
        body: 'To complement your Blood Sugar Bundle, we also recommend adding GOOD FIBES®. Its blend of 8 plant-based fiber sources, including prebiotic fibers and resistant starch, supports gut health, natural fullness, and healthy weight management while helping you increase your daily fiber intake.\n\nAvailable in both jars and convenient Travel Packs to fit your routine.',
        cta: { text: 'Explore GOOD FIBES® →', url: '/products/good-fibes' }
      },
      thinking: {
        heading: 'Thinking about a GLP-1 medication?',
        body: 'Whether or not you decide to use a GLP-1 medication, increasing your daily fiber intake can support gut health, natural fullness, and healthy weight management. GOOD FIBES® is an easy way to add more fiber to your day with a blend of 8 plant-based fiber sources, including prebiotic fibers and resistant starch.',
        cta: { text: 'Explore GOOD FIBES® →', url: '/products/good-fibes' }
      }
    },
    'good fibes': {
      yes: {
        heading: 'Using a GLP-1 medication?',
        body: 'GOOD FIBES® combines 8 plant-based fiber sources, including prebiotic fibers and resistant starch, to help increase your daily fiber intake while supporting gut health, natural fullness, and healthy weight management.\n\nAvailable in both jars and convenient Travel Packs, it’s designed to help you stay consistent wherever life takes you.'
      },
      thinking: {
        heading: 'Thinking about a GLP-1 medication?',
        body: 'Whether or not you decide to use a GLP-1 medication, increasing your daily fiber intake can help support gut health, natural fullness, and healthy weight management. GOOD FIBES® makes it easy with a blend of 8 plant-based fiber sources, including prebiotic fibers and resistant starch.\n\nAvailable in both tubs and convenient Travel Packs to fit your daily routine.'
      }
    },
    fallback: {
      yes: {
        heading: 'You’re in a great place — and GOOD FIBES® may still be a helpful foundation.',
        body: 'Since you’re using or considering a GLP-1 medication, GOOD FIBES® may be a simple way to increase your daily fiber intake and support gut health, natural fullness, and healthy weight management.\n\nAvailable in both jars and convenient Travel Packs.',
        cta: { text: 'Explore GOOD FIBES® →', url: '/products/good-fibes' }
      },
      thinking: {
        heading: 'You’re in a great place — and GOOD FIBES® may still be a helpful foundation.',
        body: 'Since you’re using or considering a GLP-1 medication, GOOD FIBES® may be a simple way to increase your daily fiber intake and support gut health, natural fullness, and healthy weight management.\n\nAvailable in both jars and convenient Travel Packs.',
        cta: { text: 'Explore GOOD FIBES® →', url: '/products/good-fibes' }
      }
    }
  };

  var RESULT_KEY_MAP = [
    { fragment: 'metabolic', key: 'metabolic' },
    { fragment: 'good fibes', key: 'good fibes' },
    { fragment: 'dihydroberberine', key: null },
    { fragment: 'db + acv', key: 'DB + ACV' },
    { fragment: 'db+acv', key: 'DB + ACV' }
  ];

  function getResultKey(resultName) {
    if (!resultName) return 'fallback';
    var lower = resultName.toLowerCase();
    for (var i = 0; i < RESULT_KEY_MAP.length; i++) {
      if (lower.indexOf(RESULT_KEY_MAP[i].fragment) !== -1) return RESULT_KEY_MAP[i].key;
    }
    return 'fallback';
  }

  function extractAnswerText(answerObj) {
    if (answerObj && Array.isArray(answerObj.selectedAnswers) && answerObj.selectedAnswers.length > 0) {
      var first = answerObj.selectedAnswers[0];
      return typeof first === 'string' ? first
        : (first.answerTitle || first.title || first.label || first.name || first.text || first.value || '');
    }
    var flat = answerObj.answer || answerObj.value || answerObj.label || answerObj.text || '';
    return typeof flat === 'string' ? flat : '';
  }

  function getGlp1Key(answers) {
    var q7Answer = '';
    if (Array.isArray(answers)) {
      for (var i = 0; i < answers.length; i++) {
        var q = answers[i].questionTitle || answers[i].question || answers[i].questionText || '';
        if (q.toLowerCase().indexOf('glp-1') !== -1 || q.toLowerCase().indexOf('medication') !== -1) {
          q7Answer = extractAnswerText(answers[i]);
          break;
        }
      }
    }
    var lower = q7Answer.toLowerCase();
    if (lower.indexOf('yes') !== -1 && lower.indexOf('considering') === -1) return 'yes';
    if (lower.indexOf('considering') !== -1 || lower.indexOf('thinking') !== -1) return 'thinking';
    return null;
  }

  function buildBlock(content) {
    var bodyLines = content.body.split('\n').map(function (line) {
      return line ? '<p>' + line + '</p>' : '';
    }).join('');
    var ctaHtml = content.cta
      ? '<a class="glp1-block__cta" href="' + content.cta.url + '">' + content.cta.text + '</a>'
      : '';
    var el = document.createElement('div');
    el.id = 'glp1-personalization';
    el.className = 'glp1-block';
    el.innerHTML =
      '<h3 class="glp1-block__heading">' + content.heading + '</h3>' +
      '<div class="glp1-block__body">' + bodyLines + '</div>' +
      ctaHtml;
    return el;
  }

  function injectBlock(block) {
    var textBlock = document.querySelector('[data-section-id="customSection_1"] .Layout-Section_Block-Text');
    if (textBlock) {
      var ctaDiv = textBlock.querySelector('p ~ div');
      if (ctaDiv) {
        textBlock.insertBefore(block, ctaDiv);
      } else {
        var descP = textBlock.querySelector('p');
        if (descP) {
          descP.insertAdjacentElement('afterend', block);
        } else {
          textBlock.appendChild(block);
        }
      }
      return;
    }
    var placeholder = document.querySelector('[data-glp-1-answer]');
    if (placeholder) {
      placeholder.innerHTML = '';
      placeholder.appendChild(block);
      return;
    }
    (document.querySelector('main') || document.body).appendChild(block);
  }

  var pendingBlock = null;

  function handleResults(detail) {
    var resultName = detail.result
      ? (detail.result.name || detail.result.title || detail.result.label || '')
      : '';
    var answers = detail.answers || detail.quizAnswers || [];
    console.log('[glp1] resultName:', resultName);
    var resultKey = getResultKey(resultName);
    var glp1Key = getGlp1Key(answers);

    if (resultKey === null || glp1Key === null) return;

    var contentMap = CONTENT[resultKey];
    if (!contentMap) return;

    var content = contentMap[glp1Key];
    if (!content) return;

    pendingBlock = buildBlock(content);
  }

  document.addEventListener('quizKitResultsPageRendered', function () {
    if (pendingBlock) {
      var existing = document.getElementById('glp1-personalization');
      if (existing) existing.parentNode.removeChild(existing);
      injectBlock(pendingBlock);
      pendingBlock = null;
    }
  });

  ['quizKitResultsPageLoaded', 'quizkit:result:loaded', 'quizKitResultLoaded', 'quiz-kit:results-loaded'].forEach(function (name) {
    window.addEventListener(name, function (e) { handleResults(e.detail || {}); });
    document.addEventListener(name, function (e) { handleResults(e.detail || {}); });
  });
})();
